<template>
    <div class="MAM_queryList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="queryForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="queryForm.channel_mer_no" placeholder="商户编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.ch_merchant_name" placeholder="商户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.agent_no" placeholder="直属代理编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.phone" placeholder="直属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.user_nickname" placeholder="直属代理名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.p2_user_nickname" placeholder="所属机构名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="queryForm.p2_phone" placeholder="所属机构账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.status" clearable placeholder="请选择调价状态">
                        <el-option label="调价成功" value="1"></el-option>
                        <el-option label="调价失败" value="2"></el-option>
                        <el-option label="调价失效" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="queryForm.brand_id" clearable placeholder="请选择政策名称">
                        <el-option
                            v-for="item in brandList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker type="date" placeholder="调价开始时间" v-model="queryForm.start_time"
                        value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
                    -
                    <el-date-picker type="date" placeholder="调价结束时间" v-model="queryForm.end_time"
                        value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
                        @click="onSearch(queryForm)">查询</el-button>

                <el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
                    :loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">

            <el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <el-table-column  width="150px"  header-align="center" align="center" prop="channel_mer_no" label="商户编号"></el-table-column>
                <el-table-column width="150px" header-align="center" align="center" prop="ch_merchant_name" label="商户名称"></el-table-column>
                 <el-table-column width="150px" header-align="center" align="center" prop="name" label="政策名称"></el-table-column>
                  <el-table-column width="150px" header-align="center" align="center" prop="nickname" label="直属代理商名称"></el-table-column> 
                  <el-table-column width="150px" header-align="center" align="center" prop="agent_no" label="直属代理商编号"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="phone" label="直属代理商账号"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="level" label="直属代理商层级"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="p2_nick_name" label="所属机构名称"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="p2_phone" label="所属机构账号"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="old_rate" label="商户调价前贷记卡费率(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="edit_rate" label="调价点(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="new_rate" label="商户调价后贷记卡费率(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="user_base_rate" label="基准价费率(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="divide_rate" label="分成费率(%)"></el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="status_text" label="调价状态">
                       <template slot-scope="scope">
                           <span v-if="scope.row.status == 1" style="color:#81B437">
                               {{scope.row.status_text}}
                           </span>
                           <span v-else  style="color:#F56C6C">{{scope.row.status_text}}</span>
                       </template>
                   </el-table-column>
                   <el-table-column width="150px" header-align="center" align="center" prop="create_time" label="调价时间"></el-table-column>  
                    <el-table-column width="150px" header-align="center" align="center" prop="failure_time" label="失效时间"></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
                @watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
        </el-card>

    </div>
</template>

<script>
    import paginations from '../../components/pagination/paginations';
    export default {
        name: "mercSpeBundDetail",
        data() {
            return {
                queryForm: {
                    type:'1',
                    start_time:'',
                    end_time:'',
                    channel_mer_no:'',
                    ch_merchant_name:'',
                    agent_no:'',
                    phone:'',
                    user_nickname:'',
                    brand_id:'',
                    status:''  //调价状态 1 有效 2无效
                },
                stockTable: { //列表
                    list: [],
                    last_total_money: 0,
                    last_nums: 0,
                    total_money_all: 0,
                },
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0, //总数
                },
                loading: true,
                downLoading: false, //导出loading
                brandList:[]
            }
        },
        mounted() {
            this.page.currentPage = 1;
            this.queryForm.page = this.page.currentPage;
            this.queryForm.limit = this.page.pageSize;
            this.getData(this.queryForm)
            this.getBrandData()
        },
        components: {
            paginations,
        },
        methods: {
            getBrandData() { // 初始化数据
                this.$api.post('brand/brand_list', {}, res => {
                    if (res.code == 0) {
                        this.brandList = res.data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            handleDownLoad(params) { //导出
                let reqData = {
                    type: 21,
                    value: JSON.stringify(params)
                };
            
                this.downLoading = true;
                this.$api.post('export/add', reqData, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.downLoading = false;
                    } else {
                        this.$message.error(res.msg);
                        this.downLoading = false;
                    }
            
                })
            },
            onSearch(queryForm) {
                this.page.currentPage = 1;
                queryForm.page = this.page.currentPage;
                queryForm.limit = this.page.pageSize;
                // 表单提交
                this.getData(queryForm);
            },
            //分页
            getCurrent(page) {
                // 获取当前页修改的值
                this.page.currentPage = page;
                this.loading = true;
                this.queryForm.page = page;
                this.queryForm.limit = this.page.pageSize;
                this.getData(this.queryForm);
            },
            getPageSize(limit) {
                this.page.currentPage = 1;
                // 获取条数发生改变的值
                this.page.pageSize = limit;
                this.loading = true;
                this.queryForm.page = this.page.currentPage;
                this.queryForm.limit = limit;
                this.getData(this.queryForm);
            },
            getData(params) {
                this.$api.post("rateup/freeChangeLogList", params, res => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.page.total = data.count; //总数
                        this.stockTable.list = res.data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                    // //渲染结束后取消加载
                    this.loading = false;
                })
            }
        }
    };
</script>

<style lang="scss" scope>
    .MAM_queryList {
        .el-input__inner {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }
    }

    .header>.el-card__body {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .headerDivd {
        padding-right: 50px;
        font-size: 14px;
        color: #E6A23C;
    }

    .headerMoney {
        font-size: 28px;
        font-weight: bold;
    }
</style>